import React, { Component } from "react";
import { isLoggedIn } from "../services/AuthenticationService";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";
import Loading from "../components/Loading";
import "./styles/dashboard.css";
import "./styles/dashboardModern.css";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import {
  Valert,
} from "../components";
import { bindActionCreators } from "redux";
import stockManagementActions from "../actions/stockManagementActions";
import connect from "react-redux/es/connect/connect";
import { Link } from "react-router-dom";
import { darkBaseTheme } from "material-ui/styles";
import { IS_UNSAVED } from "../actions/constant";

const DragHandle = SortableHandle(({ e }) => {
  return (
    <li
      style={{
        overflowWrap: "break-word",
        lineHeight: "20px",
        padding: "14px 0px",
      }}
      className="list-group-item draggable"
    >
      {e.visibility ? (
        <span className="list-group-item_counter">
          <div style={{ width: "40px", textAlign: "right" }}>
            {e.sortIndex + "."}
          </div>
        </span>
      ) : (
        ""
      )}
      <Col
        xs="10"
        style={{
          textAlign: "left",
          marginLeft: e.visibility ? "42px" : "5px",
          marginTop: "-20px",
          marginTop: e.visibility ? "-20px" : "",
        }}
      >
        {e.value.symptom}
      </Col>
    </li>
  );
});

//#region Deletable Items
const SortableItem = SortableElement((props) => {
  return <DragHandle e={props} />;
});
const SortableSeprator = SortableElement((props) => {
  let value = props.value;
  return (
    <li className="list-group-title">
      <h5>{value.title}</h5>
    </li>
  );
});
const SortableList = SortableContainer((props) => {
  let items = props.items;
  var visibility = true;
  return (
    <ul className="list-group sort-unsort">
      {items.map((value, index) => {
        if (value.type && value.type == "seprator") {
          visibility = false;
          return (
            <SortableSeprator
              key={`item-${value.order}`}
              index={value.order}
              sortIndex={index}
              value={value}
            />
          );
        } else {
          return (
            <SortableItem
              key={`item-${value.order}`}
              index={value.order}
              sortIndex={index + 1}
              value={value}
              deleteStock={props.deleteStock}
              visibility={visibility}
            />
          );
        }
      })}
    </ul>
  );
});
//#endregion Deletable Items

//#region Addable Item
const UnsortableItem = SortableElement((props) => {
  let value = props.value;
  this.add = (e) => {
    props.addStock(value._id);
  };
  return (
    <li className="list-group-item" onClick={this.add}>
      {value.name}
    </li>
  );
});
const UnsortableList = SortableContainer((props) => {
  let items = props.items;

  return (
    <ul className="list-group">
      {items.map(
        (value, index) =>
          !value.visibility && (
            <UnsortableItem
              key={`item-${index}`}
              index={index}
              value={value}
              addStock={props.addStock}
            />
          )
      )}
    </ul>
  );
});
//#endregion Addable Item
class StockManagement extends Component {
  constructor(props) {
    super(props);
    this.state = { isInitialView: true };
    this.deleteStock = this.deleteStock.bind(this);
    this.addStock = this.addStock.bind(this);
    this.onToggleView = this.onToggleView.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.props.swipeStocks(oldIndex, newIndex);
    document.body.style.cursor = "auto";
  };

  componentDidMount() {
    if (!isLoggedIn()) {
      this.props.history.push("/");
      return;
    }
    window.scroll(0, 0);
    var data = localStorage.getItem("Dashboard_User_Selected");
    data = JSON.parse(data);
    // var baseUser = localStorage.getItem('user');
    // let user = JSON.parse(baseUser);
    this.props.getStocks(data);
    localStorage.removeItem("unsavedAlertData");
    IS_UNSAVED("no");
  }
  componentWillUpdate(newProps, newState) {
    if (newProps.redirectStatus) {
      // this.props.history.push("/dashboard");
      window.location.href = `/dashboard`;
    }
  }
  componentWillUnmount() {
    localStorage.removeItem("unsavedAlertData");
    IS_UNSAVED("no");
    this.props.resetPage();
  }

  deleteStock = (_id) => {
    if (!window.confirm(this.props.t("dashboard.DELETE_CONFIRM_TEXT")))
      return false;
    this.props.deleteStock(_id);
  };

  addStock = (_id) => {
    if (!window.confirm(this.props.t("dashboard.ADD_CONFIRM_TEXT")))
      return false;
    this.props.addStock(_id);
    this.props.getStocks();
  };

  checkRedirect = () => {
    if (IS_UNSAVED() == "yes") {
      this.redirectAlert.changeStatus()
    } else {
      window.location.href = '/dashboard';
    }
  };

  onToggleView() {
    try {
      console.log(
        "Dashboard::onToggleView(), this.state.isInitialView:" +
        this.state.isInitialView
      );
      this.props.getStocks();
      this.setState({ isInitialView: !this.state.isInitialView });
    } catch (err) {
      console.log("Dashboard::onToggleView(), ERROR:" + err);
    }
  }

  onDragStart() {
    document.body.style.cursor = "grabbing";
  }

  onDragEnd() {
    document.body.style.cursor = "auto";
  }

  render() {
    const { t, currentUser } = this.props;
    const first_name = currentUser
      ? currentUser.first_name + " " + currentUser.last_name
      : "";
    // console.log("Masoud5: ", currentUser);
    var _initialViewComponent = (
      <div className="black-container dashboard-modern position-relative">
        <Loading isLoading={this.props.isLoading} />
        <Valert
          display={false}
          onRef={(ref) => (this.redirectAlert = ref)}
          title={t("dashboard.UNSAVED_SYMPTOM_CHANGES_TITLE")}
          question={t("dashboard.UNSAVED_SYMPTOM_CHANGES_TEXT")}
          positiveAction={() => {
            localStorage.removeItem("unsavedAlertData");
            IS_UNSAVED("no");
            window.location.href = '/dashboard';
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <div className="stock">
          <div className="topbar">
            {/* <i className="fa fa-plus" onClick={this.onToggleView} /> */}
            <span
              style={{
                fontWeight: "bold",
                width: "25rem",
                wordBreak: "break-all",
              }}
            >
              {/* {t("stocks.symptoms")}  */}
              {first_name}
            </span>
          </div>
          <div className="list-group-title">
            {this.props.stocks && this.props.stocks.length > 0 ? (
              <h5>{this.props.t("dashboard.SYMPTOMS_DISPLAY_TEXT")}</h5>
            ) : (
              <p
                style={{
                  color: "white",
                  padding: "30px",
                }}
              >
                {this.props.t("dashboard.NO_SYMPTOM_FOUND")}
              </p>
            )}
          </div>
          <SortableList
            items={this.props.stocks}
            redLine={this.props.redLine}
            onSortEnd={this.onSortEnd}
            useDragHandle={true}
            deleteStock={this.deleteStock}
            onSortStart={this.onDragStart}
          // onSortEnd={this.onDragEnd}
          />
          <div className="fixed-bottom px-2 pt-3 pb-3">
            <div className="d-flex justify-content-center w-100" style={{ maxWidth: '580px', margin: "auto" }}>
              <button
                type="button"
                className="btn btn-primary flex-grow-1 mr-2"
                onClick={() => this.props.pressDone(this.props.stocks, this.props.currentUser)}
                disabled={this.props.btnDoneDisabled}
              >
                {t("general.SAVE")}
              </button>
              <button
                type="button"
                className="btn btn-primary flex-grow-1"
                onClick={() => this.checkRedirect()}
              >
                {t("general.CANCEL")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );

    var _otherViewComponent = (
      <div className="black-container">
        <div className="stock">
          <div className="topbar">
            <span />
            <span />
            <span style={{ color: "blue" }} onClick={this.onToggleView}>
              {t("general.CANCEL")}
            </span>
          </div>
          <UnsortableList
            items={this.props.stocks}
            onSortEnd={this.onSortEnd}
            useDragHandle={true}
            addStock={this.addStock}
            onSortStart={this.onDragStart}
          // onSortEnd={this.onDragEnd}
          />
        </div>
      </div>
    );
    if (this.state.isInitialView) {
      return _initialViewComponent;
    } else {
      return _otherViewComponent;
    }
  }
}

StockManagement = translate("translations")(StockManagement);

const mapStateToProps = (state) => ({ ...state.stockManagement });

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...stockManagementActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(StockManagement);



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js